import PublishCollectionModal from './PublishCollectionModal.container'

export default PublishCollectionModal
